module.exports = __webpack_public_path__ + "img/afaire-logo.5d1a211c.jpg";